import $ from 'jquery';
(<any>window).jQuery = $;
(<any>window).$ = $;

import { Slider } from "./slider";
new Slider();

import { Infobox } from "./infobox";
new Infobox();

import { Imagegallery } from "./imagegallery";
new Imagegallery();

import { CookieOv } from "./cookieov";
new CookieOv();

import { AnleitungSlider } from "./anleitung-slider";
new AnleitungSlider();

$(document).ready(() => {
    $(".overlay-fixed").delay(5000).fadeOut(250);

    // Menü-Burger-Button
    $(".mainnavi-burger").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            //$("#mainnavi").removeClass("visible");
            $("#mainnavi").slideUp(250);
        } else {
            $(this).addClass("active");
            //$("#mainnavi").addClass("visible");
            $("#mainnavi").slideDown(250);
        }
    });

    // FAQs
    $(".faqs .faq A").click(function (e) {
        e.preventDefault();
        if ($(this).closest(".faq").hasClass("open")) {
            $(this).closest(".faq").removeClass("open");
            $(this).closest(".faq").find(".faqanswer").slideUp(250);
        } else {
            $(this).closest(".faqs").find(".faq").removeClass("open");
            $(this).closest(".faqs").find(".faqanswer").slideUp("open");
            $(this).closest(".faq").addClass("open");
            $(this).closest(".faq").find(".faqanswer").slideDown(250);
        }
    })
});

$(window).on("load", () => {
    window.setTimeout(function () {
        checkAnchor();
    }, 500);
    footerCols();
});

$(window).on("resize", () => {
    footerCols();
});

$(window).on("scroll", () => {

});

function footerCols() {
    var minh = 0;
    $("FOOTER .wrapper > DIV:not(.mobile-navi)").css("min-height", 0);
    $("FOOTER .wrapper > DIV:not(.mobile-navi)").each(function () {
        if ($(this).outerHeight() > minh)
            minh = $(this).height();
    });
    $("FOOTER .wrapper > DIV:not(.mobile-navi)").css("min-height", minh);
}

function checkAnchor() {

    var objfound = false;
    var $obj = null;
    var durationMS = 1000;

    if (window.location.hash) {

        if ($("A[name=" + window.location.hash.substr(1) + "]").length > 0) {
            objfound = true;
            $obj = $("A[name=" + window.location.hash.substr(1) + "]");
        } else if ($(window.location.hash)) {
            objfound = true;
            $obj = $(window.location.hash);
        }

        if (objfound) {
            var offsetTop = $obj.offset().top + $("#content").offset().top - $("HEADER").outerHeight();

            if (window.location.hash == "#gallery") {
                offsetTop -= 90;
                durationMS = 600;
            }

            if (offsetTop < 0)
                offsetTop = 0;


            $("BODY").attr("data-start", $(window).scrollTop());
            $("BODY").attr("data-stop", offsetTop);

            $obj.css("perc", 0).animate({ perc: 1 }, {
                duration: durationMS, complete: function () {
                    $("BODY").removeAttr("data-start");
                    $("BODY").removeAttr("data-stop");
                }, step: function (fx, p) {
                    var newv = Number($("BODY").attr("data-start")) - fx * (Number($("BODY").attr("data-start")) - Number($("BODY").attr("data-stop")));
                    $(window).scrollTop(newv);
                }
            });
        }
    }
}